import { Box, SimpleGrid } from "@chakra-ui/react";
import { Container } from "components";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import { Copyright } from "../Copyright";
import { isFooterCategory } from "../Footer.utils";
import { FooterLink } from "../FooterLink";
import type { FooterColumn, FooterLinksCategoryItem, FooterLinksCategoryType, FooterProps } from "../types";
import { FooterLinksCategory } from "./FooterLinksCategory";

const renderFooterCategory = ({
  _uid,
  footerLinksCategoryName,
  footerLinksCategoryItems,
  footerLinksCategoryDirection,
}: FooterLinksCategoryType) => (
  <FooterLinksCategory
    footerLinksCategoryDirection={footerLinksCategoryDirection}
    footerLinksCategoryName={footerLinksCategoryName}
    key={_uid}
  >
    {footerLinksCategoryItems.map(
      ({
        _uid,
        footerLinkItemName = "",
        footerLink,
        footerLinkIcon = "",
        footerLinkHideLinkForLanguages = undefined,
      }: FooterLinksCategoryItem) => (
        <FooterLink
          key={_uid}
          name={footerLinkItemName}
          icon={footerLinkIcon}
          footerLinkHideLinkForLanguages={footerLinkHideLinkForLanguages}
          footerLink={footerLink}
        />
      )
    )}
  </FooterLinksCategory>
);

const renderFooterColumn = ({ _uid, footerColumnContent }: FooterColumn) => (
  <Box key={_uid}>
    {footerColumnContent.map((footerColumnContentItem) =>
      isFooterCategory(footerColumnContentItem)
        ? renderFooterCategory(footerColumnContentItem)
        : renderDynamicComponent([footerColumnContentItem])
    )}
  </Box>
);

export const FooterDesktop = ({ footerColumns = [], hideFlagBox }: FooterProps) => (
  <Container data-testid="footer-section">
    <SimpleGrid pt={14} columns={footerColumns.length} spacing={12} px={4} spacingY={8} spacingX={14}>
      {footerColumns.map(renderFooterColumn)}
      <Box gridColumn="span 5" py={8} pb={10} borderTop="1px" borderColor="#e3e8f0">
        <Copyright hideFlagBox={hideFlagBox} />
      </Box>
    </SimpleGrid>
  </Container>
);
